import { getAccountNameParts } from "@/utils/accounts";
import { openSupportChat } from "libs/support";
import React from "react";
import styled from "styled-components";
import { TooltipWrapper } from "ui";
import youtubeIconUtils from "utils/youtube-icon-utils";

export interface AccountGroupOptionAccountsType {
  _id: string;
  name: string;
  avatar?: string;
  platform?: string;
  color?: string;
}

export interface AccountGroupOptionType {
  value: string;
  label: string;
  accounts: AccountGroupOptionAccountsType[];
}

export const generateAccountGroupOptions = (
  accountGroups: {
    title: string;
    accounts: {
      _id: string;
      profilePictureUrl: string | undefined;
      platformName: string | undefined;
      color: string | undefined;
      login: string;
      loginAlias: string | undefined;
    }[];
  }[]
): AccountGroupOptionType[] => {
  return accountGroups.map((accountGroup) => ({
    value: accountGroup.title,
    label: accountGroup.title,
    accounts: accountGroup.accounts.map((account) => ({
      _id: account._id,
      name: getAccountNameParts(account)[1] || "",
      avatar: account.profilePictureUrl,
      platform: youtubeIconUtils.resolvePlayIcon(
        account.platformName as string
      ),
      color: account.color,
    })),
  }));
};

export const openSupportForEnableApprovals = () => {
  openSupportChat(
    "Hey, I'd like to set up the approvals process for my account.."
  );
};

const TooltipContainer = styled.div`
  max-width: 245px;
`;

const OpenSupportChatLink = styled.span`
  cursor: pointer;
  text-decoration: underline;
`;

export const ApprovalTooltipElement = (
  <TooltipContainer>
    Please contact{" "}
    <OpenSupportChatLink onClick={() => openSupportForEnableApprovals()}>
      customer support
    </OpenSupportChatLink>{" "}
    to activate Approvals.
  </TooltipContainer>
);

export const ApprovalTooltipWrapper = ({
  show,
  children,
}: {
  children: React.ReactElement;
  show: boolean;
}) => {
  return (
    <TooltipWrapper
      tooltip={show ? ApprovalTooltipElement : undefined}
      placement={"top"}
    >
      {children}
    </TooltipWrapper>
  );
};
